module.exports = __webpack_public_path__ + "img/checked_b.74816625.svg";